/**
 * Shared hard caps for free-text and numeric form fields across features.
 * UI must set maxLength/maxDigits; Zod schemas must enforce the same ceilings.
 */
export const FORM_FIELD_LIMITS = {
  title: 120,
  shortName: 120,
  description: 2000,
  listingDescription: 5000,
  notes: 2000,
  comment: 1000,
  cancelReason: 1000,
  email: 254,
  instagram: 30,
  phoneDigits: 15,
  street: 200,
  number: 10,
  complement: 100,
  neighborhood: 100,
  city: 100,
  calendarName: 120,
  launchName: 120,
  launchAddress: 200,
  holdTtlMinutes: 10_080,
  unitLabel: 60,
  unitTower: 40,
  unitFloor: 20,
  /** CPF (14) and CNPJ (18) both fit, punctuation included. */
  partyDocument: 18,
  moneyMaxDigits: 12,
  areaMaxDigits: 7,
} as const;

export type FormFieldLimitKey = keyof typeof FORM_FIELD_LIMITS;
